var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('x-toolbar',{attrs:{"title":_vm.pageTitle}}),_c('UserCreateUpdateComponent',{attrs:{"is-edit":_vm.isEdit,"user-id":_vm.isEdit ? _vm.userId : null,"is-in-view":""},on:{"user-updated":_vm.userUpdated}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }